module.exports = window.dnn.nodeModules.ReactCollapse;